<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useConfigurationStore } from '@/stores';
const props = defineProps<{
  feature: string;
}>();

const configurationStore = useConfigurationStore();

const isEnabled = computed(() => {
  return configurationStore.isFeatureEnabled(props.feature);
});
</script>

<template>
  <div v-if="isEnabled">
    <slot></slot>
  </div>
</template>
